module.exports = __webpack_public_path__ + "img/omg_05.872722bb.png";